import { Col, Row, Typography } from 'antd';

interface FunnelBarProps {
  barBackgroundColor: string;
  containerWidth: string;
  coloredBarWidth: string;
  stageName: string;
  accumulatedStageCounter: number;
  stageCounter?: number;
  totalVacancyPositions: number;
  enabled: boolean;
}

const FunnelBar = ({
  barBackgroundColor,
  containerWidth,
  coloredBarWidth,
  stageName,
  accumulatedStageCounter,
  stageCounter,
  totalVacancyPositions,
  enabled,
}: FunnelBarProps) => {
  const greyBarColor = '#CCCCCC';
  const fontColor = barBackgroundColor === '#CF1322' ? 'white' : 'black';

  return (
    <>
      <Row gutter={[16, 16]} style={{ height: 40 }} justify="center" align="middle">
        <Col span={18}>
          <Row style={{ height: 40 }} justify="center">
            {enabled && (
              <Row style={{ backgroundColor: greyBarColor, width: containerWidth }} justify="start">
                <Row
                  style={{ backgroundColor: barBackgroundColor, width: coloredBarWidth }}
                  align="middle"
                >
                  {!!stageCounter && (
                    <Typography.Text style={{ color: fontColor, paddingLeft: '5%' }}>
                      {coloredBarWidth}
                    </Typography.Text>
                  )}
                </Row>
              </Row>
            )}
          </Row>
        </Col>
        <Col span={4} offset={2}>
          {enabled ? (
            stageName === 'Contratados' ? (
              <Typography.Text>
                {stageName}:{' '}
                <Typography.Text strong>
                  {typeof stageCounter === 'number' ? stageCounter : accumulatedStageCounter} /{' '}
                  {totalVacancyPositions}
                </Typography.Text>
              </Typography.Text>
            ) : typeof stageCounter === 'number' ? (
              <Typography.Text>
                {stageName}:{' '}
                <Typography.Text strong>
                  {stageCounter} / {accumulatedStageCounter}
                </Typography.Text>
              </Typography.Text>
            ) : (
              <Typography.Text>
                {stageName}: <Typography.Text strong>{accumulatedStageCounter}</Typography.Text>
              </Typography.Text>
            )
          ) : (
            <Typography.Text type="secondary">{stageName}: 0</Typography.Text>
          )}
        </Col>
      </Row>
    </>
  );
};

export default FunnelBar;
